/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse_CoaAccountSetMemberAttributes_ } from '../models/ControllerResponse_CoaAccountSetMemberAttributes_';
import type { ControllerResponse_CoaAccountSetMemberAttributes_Array_ } from '../models/ControllerResponse_CoaAccountSetMemberAttributes_Array_';
import type { ControllerResponse_CoaBaseAccountAttributes_Array_ } from '../models/ControllerResponse_CoaBaseAccountAttributes_Array_';
import type { ControllerResponse_string_Array_ } from '../models/ControllerResponse_string_Array_';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CoaAccountService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ControllerResponse_CoaBaseAccountAttributes_Array_ Ok
     * @throws ApiError
     */
    public listBaseAccounts(): CancelablePromise<ControllerResponse_CoaBaseAccountAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/coa_account/base',
        });
    }
    /**
     * @returns ControllerResponse_string_Array_ Ok
     * @throws ApiError
     */
    public listSets(): CancelablePromise<ControllerResponse_string_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/coa_account/sets',
        });
    }
    /**
     * @param accountSet
     * @returns ControllerResponse_CoaAccountSetMemberAttributes_Array_ Ok
     * @throws ApiError
     */
    public index(
        accountSet: string,
    ): CancelablePromise<ControllerResponse_CoaAccountSetMemberAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/coa_account',
            query: {
                'accountSet': accountSet,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_CoaAccountSetMemberAttributes_ Ok
     * @throws ApiError
     */
    public create(
        requestBody: {
            display_name: string | null;
            maps_to_base_account_id: number | null;
            base_account_id: number;
            account_set: string;
        },
    ): CancelablePromise<ControllerResponse_CoaAccountSetMemberAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/coa_account',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param accountSet
     * @returns ControllerResponse_CoaBaseAccountAttributes_Array_ Ok
     * @throws ApiError
     */
    public getDirectMembers(
        accountSet: string,
    ): CancelablePromise<ControllerResponse_CoaBaseAccountAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/coa_account/members',
            query: {
                'accountSet': accountSet,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_CoaAccountSetMemberAttributes_Array_ Ok
     * @throws ApiError
     */
    public createSet(
        requestBody: {
            name: string;
        },
    ): CancelablePromise<ControllerResponse_CoaAccountSetMemberAttributes_Array_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/coa_account/set',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param accountId
     * @param requestBody
     * @returns ControllerResponse_CoaAccountSetMemberAttributes_ Ok
     * @throws ApiError
     */
    public update(
        accountId: number,
        requestBody: {
            display_name?: string | null;
            maps_to_base_account_id?: number | null;
        },
    ): CancelablePromise<ControllerResponse_CoaAccountSetMemberAttributes_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/coa_account/{accountId}',
            path: {
                'accountId': accountId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param accountId
     * @returns void
     * @throws ApiError
     */
    public delete(
        accountId: number,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/coa_account/{accountId}',
            path: {
                'accountId': accountId,
            },
        });
    }
}
